import { render, staticRenderFns } from "./SeverityLevelFilters.vue?vue&type=template&id=00d38a82&scoped=true"
import script from "./SeverityLevelFilters.vue?vue&type=script&lang=js"
export * from "./SeverityLevelFilters.vue?vue&type=script&lang=js"
import style0 from "./SeverityLevelFilters.vue?vue&type=style&index=0&id=00d38a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d38a82",
  null
  
)

export default component.exports